import { createAction, props } from '@ngrx/store';
import { ISearchRequest } from '../Authentication/auth.models';

export enum ActionTypes {
  GET_MARKETED_PROPERTIES = '[Marketed Properties] Get Marketed Properties',
  GET_MARKETED_PROPERTIES_SUCCESS = '[Marketed Properties] Get Marketed Properties Success',
  GET_MARKETED_PROPERTIES_FAILURE = '[Marketed Properties] Get Marketed Properties Failure',

  APPROVE_MARKETED_PROPERTY = '[Marketed Properties] Approve Marketed Property',
  APPROVE_MARKETED_PROPERTY_SUCCESS = '[Marketed Properties] Approve Marketed Property Success',
  APPROVE_MARKETED_PROPERTY_FAILURE = '[Marketed Properties] Approve Marketed Property Failure',

  REJECT_MARKETED_PROPERTY = '[Marketed Properties] Reject Marketed Property',
  REJECT_MARKETED_PROPERTY_SUCCESS = '[Marketed Properties] Reject Marketed Property Success',
  REJECT_MARKETED_PROPERTY_FAILURE = '[Marketed Properties] Reject Marketed Property Failure',
}

export const getMarketedProperties = createAction(
  ActionTypes.GET_MARKETED_PROPERTIES,
  props<{ data: ISearchRequest }>(),
);

export const getMarketedPropertiesSuccess = createAction(
  ActionTypes.GET_MARKETED_PROPERTIES_SUCCESS,
  props<{ data: any }>(),
);

export const getMarketedPropertiesFailure = createAction(
  ActionTypes.GET_MARKETED_PROPERTIES_FAILURE,
  props<{ error: any }>(),
);

export const approveMarketedProperty = createAction(
  ActionTypes.APPROVE_MARKETED_PROPERTY,
  props<{ id: number; comments: string; data: ISearchRequest }>(),
);

export const approveMarketedPropertySuccess = createAction(
  ActionTypes.APPROVE_MARKETED_PROPERTY_SUCCESS,
  props<{ data: any }>(),
);

export const approveMarketedPropertyFailure = createAction(
  ActionTypes.APPROVE_MARKETED_PROPERTY_FAILURE,
  props<{ error: any }>(),
);

export const rejectMarketedProperty = createAction(
  ActionTypes.REJECT_MARKETED_PROPERTY,
  props<{ id: number; rejectionReason: string; data: ISearchRequest }>(),
);

export const rejectMarketedPropertySuccess = createAction(
  ActionTypes.REJECT_MARKETED_PROPERTY_SUCCESS,
  props<{ data: any }>(),
);

export const rejectMarketedPropertyFailure = createAction(
  ActionTypes.REJECT_MARKETED_PROPERTY_FAILURE,
  props<{ error: any }>(),
);
